import { gql } from '@apollo/client'

export const MARK_REPEAT_PRESCRIPTION_AS_STOPPED = gql`
  mutation AP_MarkRepeatPrescriptionAsStopped($id: ID!) {
    markRepeatPrescriptionAsStopped(templateId: $id)
  }
`
